export default function Logo(): React.ReactElement {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>JetBrains</title>
      <mask
        id="mask0_15531_7071"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="35"
        height="35"
      >
        <path d="M36.8633 2.8623H2.86328V36.8623H36.8633V2.8623Z" fill="white" />
      </mask>
      <g mask="url(#mask0_15531_7071)">
        <path
          d="M13.6689 4.80668L4.80766 13.6679C3.56453 14.9111 2.86328 16.6004 2.86328 18.3642V34.2061C2.86328 35.6723 4.05328 36.8623 5.5195 36.8623H21.3614C23.1251 36.8623 24.8092 36.161 26.0577 34.9179L34.9189 26.0567C36.162 24.8136 36.8633 23.1242 36.8633 21.3604V5.51853C36.8633 4.05231 35.6733 2.8623 34.207 2.8623H18.3652C16.6014 2.8623 14.9173 3.56356 13.6689 4.80668Z"
          fill="url(#paint0_linear_15531_7071)"
        />
        <path d="M28.3672 11.3613H7.11719V32.6113H28.3672V11.3613Z" fill="black" />
        <path d="M18.8008 27.8311H9.76953V29.9561H18.8008V27.8311Z" fill="white" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_15531_7071"
          x1="3.31484"
          y1="36.1823"
          x2="36.1302"
          y2="3.82387"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9419" />
          <stop offset="0.43" stopColor="#FF021D" />
          <stop offset="0.99" stopColor="#E600FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
